import { buildSelectedScooterItem } from "./micromobilityMapClient";
import { vehicleMapSelectionConfig } from "./vehicleMapSelection";

const scooterMapSelectionConfig = {
  type: "scooter",
  queryKey: "scooter",
  buildSelectedItem: buildSelectedScooterItem,
};

export const liveMapSelectionConfigs = [
  vehicleMapSelectionConfig,
  scooterMapSelectionConfig,
];
